// @flow
import styled from "styled-components";
import { Th } from "../../components/TableX";

export const ThIgnore = styled(Th)`
	width: 62px;
	font-size: 10px;
`;

export default ThIgnore;


// WEBPACK FOOTER //
// ./src/components/Draft/ThIgnore.js